import CookieConsent from '@generalassembly/cookie-consent'

if (!window.cookieConsent) {
  window.cookieConsent = new CookieConsent()
  window.cookieConsent.initBrowser()
}
